module.exports = __webpack_public_path__ + "static/media/informes-icon.c897cd03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/informes-icon.svg
// module id = 109
// module chunks = 0